import React, { useContext } from 'react';
import { useSelector, connect } from 'react-redux';

import { saveResourceModal, closeModal } from 'actions/modalActions';
import { setAlert, hideAlert } from 'actions/viewActions';
import { validateResource } from 'validation/resourceValidation';
import { canCloseModal, getActiveResource } from 'helpers/modalHelpers';
import { getUniquenessMessage } from 'actions/validationActions';

import SaveButton from 'components/common/SaveButton';
import LocaleContext from 'constants/localization';
import Modal from 'react-bootstrap/Modal';
import ResourceNavigation from './ResourceNavigation';
import ActiveResource from './ActiveResource';
import Alert from 'components/common/CustomAlert';

function ResourceModal({ saveResourceModal, closeModal, 
  validateResource, setAlert, hideAlert, alert }) {
  const LS = useContext(LocaleContext);
  
  const showAlert = useSelector(state => state.modal.showAlert);
  const showing = useSelector(state => state.modal.showing);
  const canSaveModal = useSelector(state => canCloseModal(state));
  const resource = useSelector(state => getActiveResource(state));

  const closeWithoutSaving = () => {
    hideAlert();
    closeModal();
  };

  const AlertContents = () => {
    const saveAndClose = () => {
      const { isValid, msg } = validateResource();
      const uniquenessMessage = getUniquenessMessage({format: resource.classUri }, LS);
      if (!isValid) {
        setAlert({ header: LS.validationFailTitle, variant: 'danger', contents: msg });
      } else {
        return saveResourceModal(uniquenessMessage);
      }
    };

    return (
      <div tabIndex={0} className="flex-space-evenly">
        <SaveButton label={LS.modal.saveAndCloseResource} disabled={!canSaveModal} onSubmit={saveAndClose} />
        <SaveButton label={LS.modal.closeWithoutSaving} onSubmit={closeWithoutSaving} />
        <SaveButton label={LS.modal.doNotClose} onSubmit={hideAlert} />
      </div>
    );
  };

  const confirmClose = () => {
	if(showAlert){
		setAlert({
		    header: LS.modal.closeWindowPrompt, 
		    contents: AlertContents,
		    className: 'save-alert'
	  	});
  	}else{
		closeWithoutSaving();
	}
  }

  return (
    <Modal show={showing} onHide={confirmClose}>
      <Alert alert={alert} onClose={hideAlert} />
      <Modal.Header closeButton>
        <ResourceNavigation />
      </Modal.Header>
      <Modal.Body>
        <ActiveResource />
      </Modal.Body>
    </Modal>
  );
}

const mapStateToProps = state => {
  return {
    alert: state.view.alert
  };
};

export default connect(mapStateToProps, { closeModal, saveResourceModal,
  validateResource, hideAlert, setAlert })(ResourceModal);